import { useTranslation } from 'react-i18next';

import { ControlledSelect } from '@components';
import { debtGoalOptions } from '@utils';

export interface GoalOptions {
  value: string;
  label: string;
}
export const DebtGoal = () => {
  const { t } = useTranslation('subModules/debtGoal');
  const goalOptions: GoalOptions[] = debtGoalOptions.map((option) => ({
    label: t(option.label),
    value: option.value,
  }));

  return (
    <ControlledSelect
      fieldName="debtGoal"
      label={t('label')}
      data-testid="debtGoalSubModule"
      placeholder={t('placeholder')}
      options={goalOptions}
      data-tf-sensitive="true"
      required
    />
  );
};
